module.exports = __webpack_public_path__ + "static/media/52-iveco.3ddb0b68.jpg";